
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/attorneys/dally",
      function () {
        return require("private-next-pages/attorneys/dally/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/attorneys/dally"])
      });
    }
  